// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2hJb0","itemTitle":"ClientEmergencyInfo_itemTitle__3YYZa","itemText":"ClientEmergencyInfo_itemText__3f1kB"};